var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(("itsu-logo-" + _vm.variant),{tag:"component",staticClass:"app-logo",attrs:{"focusable":"false"}})}
var staticRenderFns = []

export { render, staticRenderFns }